<template>
  <div>
    <el-upload
      class="uploadZone"
      :action="action"
      :show-file-list="isShow"
      :on-remove="handleRemove"
      :auto-upload="false"
      :on-change="uploadFiles"
      :limit="limit"
      :on-exceed="exceedFiles"
      :file-list="fileList"
      list-type="picture">
      <div class="upld"> +{{ description }} </div>
    </el-upload>
  </div>
</template>
<script>
import { uploadExtendFile } from '@/api/global'
export default {
  name: 'UploadFiles',
  props: {
    value: {
      type: String,
      default: ''
    },
    // 结果存储属性名
    valueName: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: true
    },
    description: {
      type: String,
      default: '上传补充资料'
    },
    makeUpFileList: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      fileList: [],
      fileType: ''// 上传资料类型
    }
  },
  watch: {
    makeUpFileList (val, oldVal) {
      this.fileList = val
    }
  },
  methods: {
    handleRemove (file, fileList) {
      // 根据file.name删除已上传的某一项文件
      this.$emit('deleteFile', file)
    },
    exceedFiles () {
      this.$message({
        showClose: true,
        message: '上传图片/文件个数不能超过' + this.limit + '个',
        type: 'error'
      })
    },
    uploadFiles (file, fileList) {
      const obj = {}
      const objres = fileList.reduce((item, next) => {
        // eslint-disable-next-line no-unused-expressions
        obj[next.name] ? '' : obj[next.name] = true && item.push(next)
        return item
      }, [])
      if (objres.length < fileList.length) {
        this.$message({
          showClose: true,
          message: '上传图片/文件重复',
          type: 'error'
        })
        this.fileList = [...objres]
        return false
      }

      const fileName = file.name
      const index = fileName.lastIndexOf('.')
      const suffix = fileName.substr(index)
      // 图片相关
      const isJPG = suffix === '.jpg' || suffix === '.png' || suffix === '.jpeg'
      const isLt3M = file.size / 1024 / 1024 < 3
      // 上传的图片<3M
      if (isJPG) {
        if (!isLt3M) {
          this.$message({
            showClose: true,
            message: '请上传3M以内的图片',
            type: 'error'
          })
          return false
        }
        this.fileType = 'png'
      } else {
        this.fileType = suffix.split('.')[1]
      }
      // 文档或<3M的图片直接上传
      const formData = new FormData()
      formData.append('fileType', this.fileType)
      formData.append('multipartFile', file.raw)
      // 请求接口 获取数据 之后传数据给父组件
      uploadExtendFile(formData).then(res => {
        if (parseInt(res.error_code) === 0) {
          this.$message({
            message: res.error_msg || res.result_msg,
            type: 'success'
          })
          this.$emit('success', res)
        } else {
          this.$message({
            message: res.error_msg || res.result_msg,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err)
        this.$message({
          showClose: true,
          message: '上传出错！',
          type: 'error'
        })
      })
    }
  }
}
</script>
<style scoped>
    .upld{
      width:260px;
      height:150px;
      background-color: #f0f0f0;
      color:#606260;
      line-height:150px;
      margin-left:20px;
      font-size:14px;
      box-shadow: 0 1px 6px rgba(0,0,0,.117647), 0 1px 4px rgba(0,0,0,.117647);
    }
    .uploadZone {
      height:180px
    }
    /deep/ .el-upload-list.el-upload-list--picture {
        position: relative;;
        width:280px;
        left:280px;
        top:-158px;
        margin-left:20px;
        height:160px;
        overflow-y: auto;
    }
    /deep/ .el-upload-list--picture .el-upload-list__item-name {
      margin-top:0;
    }
    /deep/ .el-upload-list--picture .el-upload-list__item {
      height:40px;
    }
    /deep/ .el-upload-list--picture .el-upload-list__item.is-success .el-upload-list__item-name {
      line-height:20px
    }
    /deep/ .el-upload-list--picture .el-upload-list__item-thumbnail {
      display:none
    }
    /deep/ .el-icon-document:before {
      content:''
    }
    /deep/ .el-upload-list--picture .el-upload-list__item {
      padding:10px 10px 10px 20px
    }
</style>
